import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// if (process.env.VUE_APP_CONST_ENV === 'dev') {
//   import('vconsole').then((module) => {
//     const VConsole = module.default;
//     new VConsole();
//   });
// }
// 埋点 -设置 eventSessionId
const { eventId, eventSessionId } = router.currentRoute.query;
if (eventId || eventSessionId) {
  sessionStorage.setItem('sls_eventSessionId', eventId || eventSessionId);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
